import React from 'react';
import styled from 'styled-components';

import { useConfig } from 'Context/ConfigContext';
import { getImagePath } from 'Util/pathUtils';
import { Box } from 'Components/Base';

const BackgroundImage = styled(Box)`
  background-image: ${({ $backgroundImage }) =>
    $backgroundImage !== '' ? `url(${getImagePath($backgroundImage)})` : 'none'};
  background-position: top center;
  background-size: cover;
  overflow: hidden;
`;

const DashboardBackground = (props) => {
  const { myCourses } = useConfig();
  return <BackgroundImage $backgroundImage={myCourses?.bannerUrl ?? ''} {...props} />;
};

export default DashboardBackground;
